import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MAPS_EXPORT_MAP_ASSET_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "kvadrat" as const

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "PBR_$MATERIAL_ARTICLE_ID$_$WIDTH_CM$x$HEIGHT_CM$cm",
    },

    // maps exports maps
    {
        type: MAPS_EXPORT_MAP_ASSET_TYPE,
        schema: "$MATERIAL_ARTICLE_ID$_$MAP_TYPE_UNDERSCORE_SEPARATED$.$EXPORT_FORMAT$",
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "3D_$MATERIAL_ARTICLE_ID$_$WIDTH_CM$x$HEIGHT_CM$cm.$IMAGE_FORMAT$",
    },

    // thumbnails
    // 7x7 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_7x7in.$IMAGE_FORMAT$",
    },

    // 9x9 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_9x9in.$IMAGE_FORMAT$",
    },

    // 10x10 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "F_$MATERIAL_ARTICLE_ID$_10x10cm.$IMAGE_FORMAT$",
    },

    // 15x15 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "F_$MATERIAL_ARTICLE_ID$_15x15cm.$IMAGE_FORMAT$",
    },

    // 16x16 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_16x16in.$IMAGE_FORMAT$",
    },

    // 20x20 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "F_$MATERIAL_ARTICLE_ID$_20x20cm.$IMAGE_FORMAT$",
    },

    // 30x30 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "F_$MATERIAL_ARTICLE_ID$_30x30cm.$IMAGE_FORMAT$",
    },

    // 8x8 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_8x8in.$IMAGE_FORMAT$",
    },

    // 13_5x13_5 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_13_5x13_5in.$IMAGE_FORMAT$",
    },

    // 27x27 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_27x27in.$IMAGE_FORMAT$",
    },

    // 32x32 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "F_$MATERIAL_ARTICLE_ID$_32x32in.$IMAGE_FORMAT$",
    },
]
